
import Cookies from "universal-cookie";
const Cookie = CreateContext();

function CreateContext(path = "/") {
    const cookies = new Cookies(null, {
        path: path,
        secure: true,
        sameSite: "lax",
    });

    return cookies;
}

export function FetchTenantIdFromCookie() {
    return +(FetchValueFromCookie("tenant_id") ?? "0");
}

export function FetchTenantNameFromCookie() {
    return FetchValueFromCookie("tenant_name");
}

function FetchValueFromCookie(prop) {

    const value = Cookie.get("queryString");
    if (value) {
        const urlParams = new URLSearchParams(value);
        return urlParams.get(prop);
    }
    return;
}


export function CreateQueryStringCookie(tenantId = -1, tenantName, redirectApp = '', agilysysSupport = false, appName = '') {
    const urlParamsAuth = new URLSearchParams();
    urlParamsAuth.set("tenant_id", tenantId.toString());
    urlParamsAuth.set("tenant_name", tenantName);
    urlParamsAuth.set("redirect_app", redirectApp);
    urlParamsAuth.set("agilysyssupport", agilysysSupport);
    Cookie.set("queryString", `?${urlParamsAuth.toString()}`);
    Cookie.set(appName + "_queryString", `?${urlParamsAuth.toString()}`);
}
